import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastGotolastNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.6892 11.0168L3.68801 2.61676C2.93461 2.05026 1.76981 2.65996 1.80011 3.59996V11.9992H16.2C16.1998 11.608 16.0077 11.2416 15.6892 11.0168Z"
        fill={color}
      />
      <path
        d="M15.6892 12.9815L3.68801 21.3815C2.93461 21.948 1.76981 21.3383 1.80011 20.3983V11.9991H16.2C16.1998 12.3903 16.0077 12.7567 15.6892 12.9815Z"
        fill={color}
      />
      <path d="M22.2 3.59998H16.2V20.4H22.2V3.59998Z" fill={color} />
      <path
        d="M16.2 20.4C16.2 21.0633 16.7367 21.6 17.4 21.6H21C21.6633 21.6 22.2 21.0633 22.2 20.4H16.2Z"
        fill={color}
      />
      <path
        d="M21 2.40002H17.4C16.7367 2.40002 16.2 2.93672 16.2 3.60002H22.2C22.2 2.93672 21.6633 2.40002 21 2.40002Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastGotolastNsk.displayName = 'PlayblastGotolastNsk';
